import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import currentUserStep from '../../../util/currentUserStep';
import { resolveNonSubscriberPath, isPortalV2Enabled } from '../../../util/portalV2';
import './UsanaLogin.css';
import SsoHandoffV2 from '../../PortalV2/Auth/SsoHandoffV2';

const UsanaLogin = () => {
    const {
        loginWithUsanaToken,
        changeLoading,
    } = useContext(AppContext);
    const history = useHistory();

    useEffect(() => {
        const handleLoginWithToken = async () => {
            // Extraer el token directamente de la URL sin que React Router lo decodifique
            const pathParts = window.location.pathname.split('/');
            const tokenFromUrl = pathParts[pathParts.length - 1];
            
            if (!tokenFromUrl || tokenFromUrl === 'UsanaLogin') {
                history.push('/login');
                return;
            }

            // Decodificar el token de la URL (convierte %2F a /, %2B a +, etc.)
            // Usar try-catch en caso de que el navegador ya haya decodificado parcialmente
            let decodedToken;
            try {
                decodedToken = decodeURIComponent(tokenFromUrl);
            } catch (e) {
                // Si falla la decodificación, usar el token tal como está
                decodedToken = tokenFromUrl;
            }
            
            changeLoading(true);
            const userStep = await loginWithUsanaToken(decodedToken);
            
            if (userStep?.data == null) {
                // Login exitoso
                if (userStep || userStep === 0) {
                    changeLoading(false);
                    if (userStep === -1) {
                        history.push(resolveNonSubscriberPath());
                    } else {
                        history.push(currentUserStep(userStep));
                    }
                }
            } else {
                // Error en el login
                changeLoading(false);
                history.push('/login?error=auth_failed');
            }
        };

        handleLoginWithToken();
    }, [history, loginWithUsanaToken, changeLoading]);

    return isPortalV2Enabled() ? (
        <SsoHandoffV2 title="Signing you in" />
    ) : null;
};

export default UsanaLogin;
